import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga';
import Privacy from 'components/Privacy'
import './app.scss';

ReactGA.initialize('UA-142477757-1', { debug: process.env.REACT_APP_ENV === 'dev' });

const App = ({ children }) => {
    const i18n = useSelector((state) => state.i18n);
    const location = useLocation();

    useEffect(() => {
        ReactGA.pageview(window.location.pathname);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        ReactGA.pageview(window.location.pathname);
    }, [location]);

    const { locale } = i18n;
    const [ lang ] = locale.split('-');
    const appClassName = classNames({
        'app': true,
        [locale.toLowerCase()]: true,
        [lang]: true,
    });

    return (
        <div className={ appClassName }>
            { children }
            <Privacy />
        </div>
    )
}

export default App;
